export default __webpack_public_path__ + "static/media/home1.5aeb4e46.svg";